import { Helmet } from "react-helmet-async";

const BASE_URL = "https://ecovillagekzo.kz";

const SEO_DATA = {
  "/": {
    title_kk: "Eco Village KZO — Қызылордадағы премиум монша кешені",
    title_ru: "Eco Village KZO — Лучшая баня в Кызылорде | Сауна с бассейном",
    desc_kk: "Eco Village KZO — Қызылорда қаласындағы ең жақсы монша кешені. 10 жеке монша үйі, бассейндер, сауна, СПА. Онлайн брондау. 11:00-02:00.",
    desc_ru: "Eco Village KZO — премиум банный комплекс в Кызылорде. 10 частных банных домов с бассейнами, сауна, СПА, массаж. Бронируйте онлайн! Работаем 11:00-02:00.",
  },
  "/houses": {
    title_kk: "Монша үйлері — Eco Village KZO | Бассейнді, отбасылық, СПА",
    title_ru: "Банные дома Кызылорда — Eco Village KZO | С бассейном, СПА",
    desc_kk: "10 жеке монша үйі: бассейнді, отбасылық, СПА. Сағатына 11 000 тг-ден. Қызылорда, Төле би к. 2к. Онлайн брондау.",
    desc_ru: "10 частных банных домов в Кызылорде: с бассейном, семейные, СПА. От 11 000 тг/час. Бронируйте онлайн на сайте Eco Village KZO!",
  },
  "/services": {
    title_kk: "Қызметтер — Eco Village KZO | Массаж, пилинг, парлау",
    title_ru: "Услуги бани — Eco Village KZO | Массаж, пилинг, парение",
    desc_kk: "Eco Village KZO қызметтері: массаж, пилинг, парлау, СПА бағдарламалар. Қызылорда қаласында кәсіби денсаулық шаралары.",
    desc_ru: "СПА услуги в бане Eco Village KZO Кызылорда: массаж, пилинг, парение с вениками, СПА-программы. Профессиональный уход за телом.",
  },
  "/menu": {
    title_kk: "Мәзір — Eco Village KZO | Тамақ тапсырысы",
    title_ru: "Меню — Eco Village KZO | Заказ еды в баню",
    desc_kk: "Eco Village KZO мәзірі: тағамдар мен сусындар тікелей монша үйіңізге. Қызылорда.",
    desc_ru: "Меню Eco Village KZO: блюда и напитки с доставкой прямо в ваш банный дом. Заказ онлайн. Кызылорда.",
  },
  "/booking": {
    title_kk: "Брондау — Eco Village KZO | Монша онлайн брондау Қызылорда",
    title_ru: "Бронирование бани — Eco Village KZO | Онлайн запись Кызылорда",
    desc_kk: "Eco Village KZO монша үйін онлайн брондаңыз. Күн мен уақытты таңдаңыз, Kaspi Pay арқылы төлеңіз. Қызылорда.",
    desc_ru: "Забронируйте баню Eco Village KZO онлайн. Выберите банный дом, дату и время. Оплата через Kaspi Pay. Кызылорда.",
  },
  "/reviews": {
    title_kk: "Пікірлер — Eco Village KZO | Қызылорда моншасы туралы",
    title_ru: "Отзывы — Eco Village KZO | О бане в Кызылорде",
    desc_kk: "Eco Village KZO туралы нақты клиенттердің пікірлері. Қызылорда қаласындағы ең жақсы монша кешені.",
    desc_ru: "Реальные отзывы клиентов о бане Eco Village KZO в Кызылорде. Узнайте, что говорят наши гости!",
  },
  "/contacts": {
    title_kk: "Байланыс — Eco Village KZO | Қызылорда, Төле би к. 2к",
    title_ru: "Контакты — Eco Village KZO | Кызылорда, Толе би 2к",
    desc_kk: "Eco Village KZO мекенжайы: Қызылорда, Төле би к. 2к. Тел: +7 702 703 30 30. WhatsApp. Карта. Жұмыс уақыты: 11:00-02:00.",
    desc_ru: "Eco Village KZO: Кызылорда, ул. Толе би 2к. Тел: +7 702 703 30 30. WhatsApp. Карта. Работаем ежедневно 11:00-02:00.",
  },
};

export default function SEOHead({ path }) {
  const lang = localStorage.getItem("eco_lang") || "kk";
  const data = SEO_DATA[path] || SEO_DATA["/"];
  const title = lang === "ru" ? data.title_ru : data.title_kk;
  const desc = lang === "ru" ? data.desc_ru : data.desc_kk;
  const canonical = `${BASE_URL}${path === "/" ? "" : path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <link rel="alternate" hreflang="kk" href={canonical} />
      <link rel="alternate" hreflang="ru" href={canonical} />
    </Helmet>
  );
}
